<template>
  <div id="app">
    <Header :user="user"></Header>
    <router-view :user="user" :isCheckingLogin="isCheckingLogin"></router-view>
    <Footer :user="user"></Footer>
    <CookieAlert></CookieAlert>
  </div>
</template>

<script>
//import AOS from 'aos';
import * as Cookies from 'js-cookie';
import axios from 'axios/dist/axios';
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';
import CookieAlert from './components/CookieAlert.vue';

export default {
  name: 'App',
  data() {
    return {
      user: undefined,
      token: undefined,
      isCheckingLogin: false
    }
  },
  components: {
    Header,
    Footer,
    CookieAlert
  },
  created: function() {
    this.$eventBus.$on('user:login', this.onUserLogin);
    this.$eventBus.$on('user:logout', this.ouUserLogout);

    const token = Cookies.get('caramba-token');
    const headers = { 'Authorization': 'Bearer ' + token };
    const refreshTokenInstance = axios.create({headers});

    if(token) {
      this.isCheckingLogin = true;
      refreshTokenInstance.post('/api/refresh', {token})
        .then(resp => {
          Cookies.set('caramba-token', resp.data.token, {expires: 14});
          this.getUser(resp.data.token);
        })
        .catch(err => {
          this.isCheckingLogin = false;
          this.logout();
        });
    }

    console.log("We're here to stay!! Long live Vue");
    //setInterval(() => AOS.init(), 200);
  },
  methods: {
    getUser: function(token) {
      const headers = { 'Authorization': 'Bearer ' + token };
      const getUserInstance = axios.create({headers});
      getUserInstance.post('/api/v1/user/get', {token})
        .then(resp => {
          this.isCheckingLogin = false;
          this.user = resp.data;
          this.$eventBus.$emit('login:complete');
        })
        .catch(err => {
          this.isCheckingLogin = false;
          this.logout();
        });
    },

    onUserLogin: function(data) {
      this.user = data.user;
      Cookies.set('caramba-token', data.token, {expires: 14});
      this.$router.push('/user');
    },

    ouUserLogout: function(options) {
      this.logout();
      if(options.goToLogin) {
        this.$router.push('/login');
      }
    },

    logout: function() {
      this.user = undefined;
      Cookies.remove('caramba-token');
    }
  }
}
</script>

<style>

  /*@import 'aos/dist/aos.css';*/

</style>



// WEBPACK FOOTER //
// src/vue/App.vue